import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function PersonLink({ id, name, className = '', to = '/perfil' }) {
  const navigate = useNavigate();
  const { switchUser } = useAuth();

  if (!id || !name) return <span className={className}>{name || '-'}</span>;

  const handleClick = async (e) => {
    e.stopPropagation();
    await switchUser(id);
    navigate(to);
  };

  return (
    <span
      onClick={handleClick}
      className={`text-[#0F1829] hover:underline cursor-pointer ${className}`}
      title={`Ver perfil de ${name}`}
    >
      {name}
    </span>
  );
}
